// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stability_stability-info__wN7mD {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
}
.stability_stability-info__title__7ye9C {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.stability_stability-info__content__OMNIB {
  padding: 10px 0;
}
.stability_stability-info__items__j1ezg {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.stability_stability-info__item__v7uP- {
  background-color: #f9f9f9;
  border-left: 4px solid #ff4d4f;
  padding: 12px 16px;
  border-radius: 4px;
}
.stability_stability-info__item-title__mPhHO {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}
.stability_stability-info__item-description__PeRg8 {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}
.stability_stability-info__empty__tbIFR {
  color: #999;
  font-style: italic;
  text-align: center;
  padding: 20px;
}

.stability_stabilityContainer__FSh7Z {
  background-color: #444;
  color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 95%;
  margin: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.stability_stabilityTitle__yGbPf {
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.stability_stabilityGrid__pUZ14 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.stability_stabilityCard__WfDHH {
  background-color: #333;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.stability_stabilityCard__WfDHH:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.stability_cardHeader__oC20R {
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.stability_cardIcon__\\+s0vQ {
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stability_cardTitle__670KE {
  margin: 0;
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.stability_cardBody__cf-EP {
  padding: 15px;
  background-color: #222;
}

.stability_cardDescription__fEXad {
  margin: 0;
  color: #e0e0e0;
  line-height: 1.6;
  font-size: 14px;
}

.stability_emptyMessage__YS5Om {
  background-color: #333;
  padding: 30px;
  text-align: center;
  border-radius: 8px;
}
.stability_emptyMessage__YS5Om p {
  color: #999;
  font-style: italic;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Summary/stability/stability.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,oBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAIE;EACE,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AAFJ;AAII;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAFN;AAKI;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAHN;AAOE;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AALJ;;AASA;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;AANF;;AASA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AANF;;AASA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AANF;;AASA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qDAAA;EACA,yCAAA;AANF;AAQE;EACE,2BAAA;EACA,yCAAA;AANJ;;AAUA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAPF;;AAUA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;AAPF;;AAUA;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAPF;;AAUA;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAPF;AASE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;AAPJ","sourcesContent":[".stability-info {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  margin-bottom: 20px;\n  \n  &__title {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 16px;\n    color: #333;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 10px;\n  }\n  \n  &__content {\n    padding: 10px 0;\n  }\n  \n  &__items {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  &__item {\n    background-color: #f9f9f9;\n    border-left: 4px solid #ff4d4f;\n    padding: 12px 16px;\n    border-radius: 4px;\n    \n    &-title {\n      font-size: 16px;\n      font-weight: 600;\n      margin-bottom: 8px;\n      color: #333;\n    }\n    \n    &-description {\n      font-size: 14px;\n      color: #666;\n      line-height: 1.5;\n    }\n  }\n  \n  &__empty {\n    color: #999;\n    font-style: italic;\n    text-align: center;\n    padding: 20px;\n  }\n}\n\n.stabilityContainer {\n  background-color: #444;\n  color: #fff;\n  padding: 20px;\n  border-radius: 5px;\n  width: 95%;\n  margin: auto;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.stabilityTitle {\n  text-align: center;\n  color: #ffffff;\n  margin-bottom: 20px;\n  font-size: 24px;\n  font-weight: 600;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.stabilityGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.stabilityCard {\n  background-color: #333;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  \n  &:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n  }\n}\n\n.cardHeader {\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.cardIcon {\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cardTitle {\n  margin: 0;\n  color: white;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.cardBody {\n  padding: 15px;\n  background-color: #222;\n}\n\n.cardDescription {\n  margin: 0;\n  color: #e0e0e0;\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.emptyMessage {\n  background-color: #333;\n  padding: 30px;\n  text-align: center;\n  border-radius: 8px;\n  \n  p {\n    color: #999;\n    font-style: italic;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stability-info": `stability_stability-info__wN7mD`,
	"stability-info__title": `stability_stability-info__title__7ye9C`,
	"stability-info__content": `stability_stability-info__content__OMNIB`,
	"stability-info__items": `stability_stability-info__items__j1ezg`,
	"stability-info__item": `stability_stability-info__item__v7uP-`,
	"stability-info__item-title": `stability_stability-info__item-title__mPhHO`,
	"stability-info__item-description": `stability_stability-info__item-description__PeRg8`,
	"stability-info__empty": `stability_stability-info__empty__tbIFR`,
	"stabilityContainer": `stability_stabilityContainer__FSh7Z`,
	"stabilityTitle": `stability_stabilityTitle__yGbPf`,
	"stabilityGrid": `stability_stabilityGrid__pUZ14`,
	"stabilityCard": `stability_stabilityCard__WfDHH`,
	"cardHeader": `stability_cardHeader__oC20R`,
	"cardIcon": `stability_cardIcon__+s0vQ`,
	"cardTitle": `stability_cardTitle__670KE`,
	"cardBody": `stability_cardBody__cf-EP`,
	"cardDescription": `stability_cardDescription__fEXad`,
	"emptyMessage": `stability_emptyMessage__YS5Om`
};
export default ___CSS_LOADER_EXPORT___;
